import Vue from 'vue'
import Router from 'vue-router'

import Index from "./components/pages/index";
import About from "./components/pages/about";
import Login from "./components/pages/login";
import Test from "./components/pages/test";
import Download from "./components/pages/download";
// import TestShiraishi from "./components/pages/test-shiraishi";
// import TestShiraishi2 from "./components/pages/test-shiraishi2";
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: "/about",
      component: About
    },
    {
      path: "/login",
      component: Login,
      meta: { isPublic: true }
    },
    {
      path: "/test",
      component: Test
    },
    {
      path: "/download",
      component: Download
    }
    // 不必要なためコメントアウト。リリース時に削除します。
    // {
    //   path: "/test-shiraishi",
    //   component: TestShiraishi
    // },
    // {
    //   path: "/test-shiraishi2",
    //   component: TestShiraishi2
    // }
  ]
})